import { render, staticRenderFns } from "./Jp.vue?vue&type=template&id=3f507d8c&scoped=true&"
import script from "./Jp.vue?vue&type=script&lang=js&"
export * from "./Jp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f507d8c",
  null
  
)

export default component.exports